import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ThumbsUp } from 'lucide-react';
import apiClient from '../utils/apiClient';

export default function SkillFeedbackStats({ skillPackageId, skillType = 'marketplace', compact = false }) {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, [skillPackageId]);

  const fetchStats = async () => {
    try {
      const response = await apiClient.get(`/skills/feedback/stats/${skillPackageId}`, {
        params: { skillType }
      });
      setStats(response.data);
    } catch (error) {
      console.error('Failed to fetch feedback stats:', error);
      // Fail silently for stats
    } finally {
      setLoading(false);
    }
  };

  if (loading || !stats || stats.totalFeedback === 0) {
    return null;
  }

  if (compact) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-gray-600">
        <ThumbsUp className="w-3.5 h-3.5" />
        <span className="font-medium">{stats.positivePercentage}%</span>
        <span className="text-gray-400">({stats.totalFeedback})</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-sm">
      <div className="flex items-center gap-1.5 text-green-600">
        <ThumbsUp className="w-4 h-4" />
        <span className="font-semibold">
          {t('feedback.helpfulPercentage', { percent: stats.positivePercentage })}
        </span>
      </div>
      <span className="text-gray-500">
        {t('feedback.ratings', { count: stats.totalFeedback })}
      </span>
    </div>
  );
}
